import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

const TermsAndConditions = () => {
  const [terms, setTerms] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  // fetch t&c
  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/terms-and-conditions`
        );

        const sortedTerms = [
          "Terms and Conditions",
          "Shipping and Delivery",
          "Cancellation and Refund",
        ].map((title) =>
          response.data.data
            .map((item) => ({ id: item.id, ...(item.attributes || item) }))
            .find((attr) => attr.title === title)
        );

        console.log("sortedTerms: ", sortedTerms);

        setTerms(sortedTerms);
      } catch (error) {
        console.error("Error fetching terms:", error);
      }
    };

    fetchTerms();
  }, []);

  return (
    <div className="p-4 min-h-screen bg-gray-100 dark:bg-gray-900">
      <h1 className="text-2xl font-bold text-center mb-6">
        Terms and Conditions
      </h1>

      {terms.length > 0 ? (
        <div>
          {terms.map((term, index) => (
            <div key={term.title} className="mb-6 ml-5 mr-5">
              <h2
                onClick={() => setActiveIndex(index)}
                className={`cursor-pointer flex items-center text-xl font-semibold transition-colors duration-300 ${
                  index === activeIndex
                    ? "text-blue-600 dark:text-blue-600"
                    : "text-gray-800 dark:text-gray-300"
                }`}
              >
                {term.title}
                {index === activeIndex ? (
                  <FaChevronUp className="ml-2" />
                ) : (
                  <FaChevronDown className="ml-2" />
                )}
              </h2>

              {index === activeIndex && (
                <div className="mt-4 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md">
                  <p className="text-sm text-gray-500 dark:text-gray-400 italic mb-3">
                    {term.lastUpdated}
                  </p>
                  <div
                    className="text-gray-700 dark:text-gray-200"
                    dangerouslySetInnerHTML={{ __html: term.description }}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-600 dark:text-gray-400">
          Loading terms...
        </p>
      )}
    </div>
  );
};

export default TermsAndConditions;
